import React from "react";

// PageHeader (Cihazlar/Firmalar) ile aynı ikon çipi paleti.
const COLOR_MAP = {
  blue: { gradient: "from-blue-50 to-indigo-50", border: "border-blue-100" },
  indigo: { gradient: "from-indigo-50 to-purple-50", border: "border-indigo-100" },
  emerald: { gradient: "from-emerald-50 to-green-50", border: "border-emerald-100" },
  amber: { gradient: "from-amber-50 to-yellow-50", border: "border-amber-100" },
};

export default function DashboardSectionCard({
  icon,
  title,
  subtitle,
  actions,
  children,
  className = "",
  maxHeight,
  color = "blue",
}) {
  const c = COLOR_MAP[color] || COLOR_MAP.blue;

  return (
    <div
      className={`bg-white rounded-2xl shadow-sm overflow-hidden border border-gray-200 flex flex-col ${className}`}
      style={maxHeight ? { maxHeight } : undefined}
    >
      {/* Header — diğer sayfalardaki PageHeader diliyle aynı */}
      <div className="bg-gray-50 p-3 sm:p-4 border-b border-gray-200 shrink-0">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2 sm:gap-3">
            {icon && (
              <div className={`p-1.5 sm:p-2 bg-gradient-to-br ${c.gradient} rounded-lg sm:rounded-xl shadow-sm border ${c.border}`}>
                {icon}
              </div>
            )}
            <div>
              {title && (
                <h3 className="text-base sm:text-xl font-bold text-gray-900">
                  {title}
                </h3>
              )}
              {subtitle && (
                <p className="text-xs sm:text-sm text-gray-500 mt-0.5">
                  {subtitle}
                </p>
              )}
            </div>
          </div>
          {actions && <div className="flex items-center gap-2">{actions}</div>}
        </div>
      </div>

      {/* Content */}
      {children}
    </div>
  );
}
